define('v3/Pages/Settings/Services/Lvs.Backend',[
	'jquery',
	'BackendBase'

], function ($, BackendBase) {
	function LvsBackend () {
		BackendBase.call(this);
	}

	LvsBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(LvsBackend.prototype, {
		getLvsSyncStatus: function (schoolId) {
			var url = Settings.dataExchangeApi;
			return this._getJsonApiWithJwtAuthorization(
				url + '/schools/' + schoolId + '/features', null, { showError: false });
		}
	});

	return new LvsBackend();
});
